import { render, staticRenderFns } from "./HighlightIcon.vue?vue&type=template&id=63e16e8e&scoped=true&"
import script from "./HighlightIcon.vue?vue&type=script&lang=ts&"
export * from "./HighlightIcon.vue?vue&type=script&lang=ts&"
import style0 from "./HighlightIcon.vue?vue&type=style&index=0&id=63e16e8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e16e8e",
  null
  
)

export default component.exports